import React from 'react';
import { cn } from '@/lib/utils';

type ErrorStateProps = {
  title?: string;
  message?: string;
  onRetry?: () => void;
  className?: string;
};

export const ErrorState: React.FC<ErrorStateProps> = ({ title = 'Algo deu errado', message, onRetry, className }) => {
  return (
    <div className={cn("w-full flex flex-col items-center justify-center text-center p-6 border rounded-md bg-destructive/5", className)}>
      <h3 className="text-base font-medium mb-1 text-destructive">{title}</h3>
      {message && <p className="text-sm text-muted-foreground mb-3">{message}</p>}
      {onRetry && (
        <button
          className="inline-flex items-center px-3 py-2 rounded-md bg-primary text-primary-foreground"
          onClick={onRetry}
        >
          Tentar novamente
        </button>
      )}
    </div>
  );
};


